import LayerImportTab from './views/LayerImportTab';
import LayersCatalogTab from './views/LayersCatalogTab';
import LayersGeoserviceTab from './views/LayersGeoserviceTab';

import TabModal from '../../../TabModal';

import AppContext from '@map/services/context';
/**
 * useContext usado para forcener uma maneira de passar dados
 * pela arvore de componentes sem ter que passar props manualmente
 * em todos os níveis.
 * 
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 * 
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 * 
 * useMemo é um hook que retorna um valor memorizado.
 */
import { useContext, useState, useEffect, useMemo } from 'react';
/**
 *  useModules é responsavel por gerenciar os modulos do GeoBahia,
 *  todos os módulos criados na ADM.
 */
import { useModule } from 'views/MapView/hooks';

/**
 * Função responsavel por colocar titulos nas opçoes de importação
 * 
 * @param {*} props 
 * 
 * @returns tabModal
 */
const LayersCatalog = (props) => {
  const availableViews = useMemo(
    () => [
      {
        title: 'Catálogo de Camadas',
        Component: <LayersCatalogTab />,
        valid: true,
      },
      {
        title: 'Importar Camada',
        Component: <LayerImportTab />,
        valid: true,
      },
      {
        title: 'Geoserviço',
        Component: <LayersGeoserviceTab />,
        valid: true,
      },
    ],
    []
  );

  const context = useContext(AppContext);
  const { getElement, activeModule } = useModule();
  const { layersCatalogIsOpened, genericSetContextProp } = context;
  const [views, setViews] = useState([]);

  useEffect(() => {
    if (activeModule) {
      let config = getElement('CPN-MP-MENU_LAYERS').configuracao;
      if (config) {
        let configViews = [];
        config.catalogTab !== false && configViews.push(availableViews[0]);
        config.importTab !== false && configViews.push(availableViews[1]);
        config.geoserviceTab !== false && configViews.push(availableViews[2]);
        setViews(configViews);
      } else {
        setViews(availableViews);
      }
    }
  }, [activeModule, getElement, availableViews]);

  return (
    <TabModal
      title="Camadas"
      open={layersCatalogIsOpened}
      onClose={() => genericSetContextProp('layersCatalogIsOpened', false)}
      views={views}
    />
  );
};

LayersCatalog.properties = {
  id: 'CPN-MP-LAYERS_CATALOG',
  ignore: true,
  alias: 'Catálogo de Camadas',
  description:
    'Modal de catálogo de camadas para adicionar mais camadas não padrão à um mapa',
};

export default LayersCatalog;
